import I18n from 'translations/i18n'
import classNames from 'classnames'
import { Text, Spacer, Flex } from '@jisr-hr/design-system'
import { ReactComponent as ArrowIcon } from '@jisr-hr/design-system/dist/assets/icons/down-arrow.svg'
import { ViewedComponent } from 'components/authorised/Performace'
import styles from '../styles.module.css'

type FilterBoxHeaderProps = {
  handleCollabseFilterBox: () => void
  handleClearFilter: () => void
  canShowClear: boolean
  title: string
  isCollapsed: boolean
}

const FilterBoxHeader = (props: FilterBoxHeaderProps): JSX.Element => {
  const { handleCollabseFilterBox, handleClearFilter, title, canShowClear, isCollapsed } = props

  const iconProps = {
    className: classNames(styles.arrowIcon, !isCollapsed && styles.arrowIconCollapsed),
    onClick: handleCollabseFilterBox,
  }

  return (
    <div>
      <Flex
        justifyBetween
        onClick={handleCollabseFilterBox}
        style={{ cursor: 'pointer' }}
      >
        <ViewedComponent available={!!title}>
          <Text
            data-testid={`title-filter-${title}`}
            weight="bold"
            typography="paragraph16"
          >
            {I18n.t(title)}
          </Text>
        </ViewedComponent>
        <Flex itemsCenter>
          <ViewedComponent available={canShowClear}>
            <Text
              typography="paragraph14"
              style={{
                cursor: 'pointer',
                color: 'var(--color-brand-primary-default-new)',
              }}
              onClick={handleClearFilter}
            >
              {I18n.t('clear')}
            </Text>
          </ViewedComponent>
          <Spacer width={8} />
          <ArrowIcon {...iconProps} />
        </Flex>
      </Flex>
    </div>
  )
}

export default FilterBoxHeader
